import CryptoJS from "crypto-js";
import qs from "qs";
import axios from "axios";
import VueCookies from "vue-cookies";
import { nanoid } from "nanoid";
import COS from "cos-js-sdk-v5";
import { message } from "ant-design-vue";
import router from "../router";

export default {
  options: {
    Bucket: "91jf-10046268",
    Region: "ap-shanghai",
    StorageClass: "STANDARD",
  },
  expiredTime: null,
  cos: null,
  api(url, params, callback, repType = "") {
    const CancelToken = axios.CancelToken;
    const CancelTokenSource = CancelToken.source();

    var nowDate = new Date();
    var dateTime = nowDate.toUTCString();
    var SecretId = "AKID2K20vPpcljlggskgd8o2SPe8Ddlioge4lcs4";
    var SecretKey = "I0bTrvC4571fcgvxfXzUl327s5n37djC29Y72yIC";
    var source = "member";
    var auth =
      'hmac id="' +
      SecretId +
      '", algorithm="hmac-sha1", headers="x-date source", signature="';
    var signStr = "x-date: " + dateTime + "\n" + "source: " + source;
    var sign = CryptoJS.HmacSHA1(signStr, SecretKey);
    var host = window.location.host;
    var baseURL = "/api";
    var AccessToken =
      VueCookies.get("AccessToken") == null
        ? ""
        : VueCookies.get("AccessToken");

    if (host.indexOf(":8080") == -1 && host.indexOf(":8083") == -1) {
      baseURL = "https://member-api.91jf.com";
    }
    // baseURL = "https://member-api.91jf.com";

    sign = CryptoJS.enc.Base64.stringify(sign);
    sign = auth + sign + '"';

    var ip =
      VueCookies.get("sourceip") == null
        ? this.getIp()
        : VueCookies.get("sourceip");

    var instance = axios.create({
      baseURL: baseURL,
      timeout: 10000,
      headers: {
        Source: source,
        "X-Date": dateTime,
        Authorization: sign,
        AccessToken: AccessToken,
        SourceIp: ip,
      },
      withCredentials: true,
      responseType: repType,
      cancelToken: CancelTokenSource.token, 
    });

    if (!params) {
      params = {};
    }
    // console.log(url);
    instance
      .post(url, qs.stringify(params))
      .then(function (response) {
        if (axios.isCancel(response)) return;

        var status = response.status;
        var data = response.data;

        if (status != 200) {
          console.log("请求失败，状态码：" + status);
        }
        //特定的状态码判断
        if ([10036, 10037, 10038, 10039, 10040].includes(response.data.code)) {
          if(window.location.pathname !='/pay/page'){
            router.push("/login");
          }

        }

        if (callback) {
          callback(data);
        }
      })
      .catch(function (error) {
        // message.error('链接超时，请稍后再试')
        // setTimeout(() => {
        //
        //   window.location.reload();
        //
        // }, 1000);
        if (axios.isCancel(error)) {
            console.log("url:"+url+",请求已取消:", error); // 处理取消的请求
        } else {
            console.log(error); // 处理其他错误
        }
      });

      return CancelTokenSource;
  },
  loginStatus() {
    var token = VueCookies.get("AccessToken");

    if (token == null) {
      return false;
    }

    // var end_time = VueCookies.get('EndTime') == null ? 0 : VueCookies.get('EndTime');
    // var this_time = Math.round(new Date().getTime()/1000);

    // if(parseInt(end_time) < parseInt(this_time)){
    //     VueCookies.remove('AccessToken');
    //     VueCookies.remove('EndTime');
    //     VueCookies.remove('UserInfo');
    //     return false;
    // }

    return true;
  },
  userinfo() {
    return VueCookies.get("UserInfo");
  },
  getId() {
    return nanoid();
  },
  getTempSecret() {
    var _this = this;
    return new Promise((resolve, reject) => {
      const now = Math.floor(new Date().getTime() / 1000);
      const { expiredTime } = this;
      if (expiredTime && now < expiredTime) {
        resolve();
      } else {
        let params = {};
        _this.api("/cos", params, function (res) {
          if (res.code == 10000) {
            let params = {
              TmpSecretId: res.data.secret_id,
              TmpSecretKey: res.data.secret_key,
              SecurityToken: res.data.session_token,
              ExpiredTime: res.data.expired_time,
            };
            _this.expiredTime = res.data.expired_time;
            _this.cos = new COS({
              getAuthorization: (options, callback) => {
                callback(params);
              },
            });
            resolve();
          } else {
            reject();
          }
        });
      }

      //测试使用，打包上线删除
      // this.cos = new COS({
      //   SecretId: 'AKIDM3aDQ27VkYgWjYcxKuYkRGlwaKwoBq3d',
      //   SecretKey: 'E1MYfiqALcPACOuJ0cG0uZYhNiGbWZF0',
      // })
      // resolve()
    });
  },
  getImageUrl: async function (key) {
    await this.getTempSecret();
    return new Promise((resolve, reject) => {
      const { Bucket, Region } = this.options;
      this.cos.getObjectUrl({ Bucket, Region, Key: key }, (err, data) => {
        if (err) {
          reject();
          return;
        }

        resolve(data.Url.substring(0, data.Url.lastIndexOf("?")));
      });
    });
  },
  //上传图片到云存储
  cosUpload: async function (key, file, onProgress = () => {}) {
    //获取身份ID和秘钥
    await this.getTempSecret();
    //图片上传
    var _that = this;
    return new Promise((resolve, reject) => {
      _that.cos.putObject(
        {
          Key: key, // 文件名
          Body: file, //要上传的文件对象
          onProgress, //进度条
          ..._that.options,
        },
        (err, data) => {
          if (data && data.statusCode === 200) {
            //成功，获取图片路径
            let imageUrl = "";
            _that.getImageUrl(key).then((url) => {
              resolve(
                url.replace(
                  "91jf-10046268.cos.ap-shanghai.myqcloud.com",
                  "img2.91jf.com"
                )
              );
            });
          } else {
            message.error("上传错误，请重试");
            reject(err);
          }
        }
      );
    });
  },
  //从云存储下载
  download: async function (key) {
    await this.getTempSecret();
    const { Bucket, Region } = this.options;
    this.cos.getObjectUrl({ Bucket, Region, Key: key }, (err, data) => {
      if (err) {
        message.error("下载出错,请重试");
        return;
      }
      let url = data.Url.replace(
        "91jf-10046268.cos.ap-shanghai.myqcloud.com",
        "img2.91jf.com"
      );
      const downloadUrl =
        url +
        (url.indexOf("?") > -1 ? "&" : "?") +
        "response-content-disposition=attachment"; // 补充强制下载的参数
      window.open(downloadUrl);
    });
  },
  //删除云存储
  cosDel: async function (key) {
    await this.getTempSecret();
    const { Bucket, Region } = this.options;

    return new Promise((resolve, reject) => {
      this.cos.deleteObject({ Bucket, Region, Key: key }, (err, data) => {
        if (err) {
          console.log(err);
          message.error("删除图片出错,请重试");
          return;
        } else {
          message.error("删除成功");
          return;
        }
      });
    });
  },
  isEmpty(value) {
    if (!value) return true;

    if (value instanceof Object) {
      return Object.keys(value).length === 0;
    } else if (value instanceof Array) {
      return value.length === 0;
    }
    return false;
  },
  deleteItem(arr, value, key = "") {
    let index = arr.findIndex((item) => {
      if (key === "") {
        return item === value;
      } else {
        return item[key] === value;
      }
    });
    console.log(index);
    if (index === -1) return;

    arr.splice(index, 1);
  },
  vip(money) {
    money = parseInt(money);

    if (money <= 0) {
      return 0;
    } else if (money < 10000) {
      return 1;
    } else if (money < 100000) {
      return 2;
    } else {
      return 3;
    }
  },
  dateFormat(date, fmt) {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    }
    let o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + "";
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? str : padLeftZero(str)
        );
      }
    }
    return fmt;
  },
  inArray(search, array) {
    for (var i in array) {
      if (array[i] == search) {
        return true;
      }
    }
    return false;
  },
  getHost() {
    var host = window.location.host;

    if (host.indexOf(":8080") == -1) {
      host = "https://www.91jf.com/";
    } else {
      host = "http://" + host.replace(":8080", "") + "/";
    }

    return host;
  },
  starStr(value) {
    let start = value.slice(0, 3);
    let end = value.slice(-4);
    return `${start}****${end}`;
  },
  getIp() {
    axios
      .get("https://ip.91jf.com/vuegetip.php", {})
      .then((resp) => {
        var status = resp.status;
        var data = resp.data;

        if (status != 200) {
          console.log("ip获取失败");
        }
        VueCookies.set("sourceip", data);
      })
      .catch((err) => {
        console.log(err);
      });
  },
  api_login(url, params, callback, repType = "") {
    var nowDate = new Date();
    var dateTime = nowDate.toUTCString();
    var SecretId = "AKID2K20vPpcljlggskgd8o2SPe8Ddlioge4lcs4";
    var SecretKey = "I0bTrvC4571fcgvxfXzUl327s5n37djC29Y72yIC";
    var source = "member";
    var auth =
      'hmac id="' +
      SecretId +
      '", algorithm="hmac-sha1", headers="x-date source", signature="';
    var signStr = "x-date: " + dateTime + "\n" + "source: " + source;
    var sign = CryptoJS.HmacSHA1(signStr, SecretKey);
    var host = window.location.host;
    var baseURL = "/api";
    var AccessToken =
      VueCookies.get("AccessToken") == null
        ? ""
        : VueCookies.get("AccessToken");

    if (host.indexOf(":8080") == -1) {
      // baseURL = 'https://service-ededm21t-1251116573.sh.apigw.tencentcs.com';
      baseURL = "https://member-api.91jf.com";
    }

    sign = CryptoJS.enc.Base64.stringify(sign);
    sign = auth + sign + '"';

    var ip =
      VueCookies.get("sourceip") == null
        ? this.getIp()
        : VueCookies.get("sourceip");

    var instance = axios.create({
      baseURL: baseURL,
      timeout: 10000,
      headers: {
        Source: source,
        "X-Date": dateTime,
        Authorization: sign,
        AccessToken: AccessToken,
        SourceIp: ip,
      },
      withCredentials: true,
      responseType: repType,
    });

    if (!params) {
      params = {};
    }
    // console.log(url);
    instance
      .post(url, qs.stringify(params))
      .then(function (response) {
        var status = response.status;
        var data = response.data;

        if (status != 200) {
          console.log("请求失败，状态码：" + status);
        }
        //特定的状态码判断
        // if ([10036,10037,10038,10039,10040].includes(response.data.code)) {
        //     router.push('/login')
        // }

        if (callback) {
          callback(data);
        }
      })
      .catch(function (error) {
        // message.error('链接超时，请稍后再试')
        // setTimeout(() => {
        //
        //   window.location.reload();
        //
        // }, 1000);
        console.log(error);
      });
  },

  Copy(order){
    if(navigator.clipboard){
      this.Copy = order =>{
        navigator.clipboard.writeText(order).then(()=>{
          message.success("复制成功");
        })
      }
    }else{
      this.Copy = order =>{
        const input = document.createElement("input");
        input.setAttribute("value", order);
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        message.success("复制成功");
      }
    }
    this.Copy(order)
  }
};



// WEBPACK FOOTER //
// ./src/utils/util.js